import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import {
  sisenseFetchFormData,
  sisenseClearStateForm,
  sisenseChange,
} from 'reducers/sisense/reducer'
import { fetchProfile } from 'reducers/profile/reducer'
import SisenseForm from 'components/sisense/SisenseForm'
import withPromise from 'helpers/withPromise'
import Loader from 'components/Loading'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import messages from './translate'

class SisenseDashboardItem extends Component {
  UNSAFE_componentWillMount() {
    const { sisenseFetchFormData } = this.props
    sisenseFetchFormData({
      entityId: this.getEntityId(),
    })
  }

  componentWillUnmount() {
    const { sisenseClearStateForm } = this.props

    sisenseClearStateForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : 0
  }

  onSubmit = async values => {
    const {
      sisenseChange,
      fetchProfile,
      history: { goBack },
    } = this.props
    const formatValues = { ...values }
    const { translations: formTranslations } = values
    const translations = []

    Object.keys(formTranslations).forEach(key => {
      const translation = formTranslations[key]
      translations.push({
        ...translation,
        locale: key,
      })
    })

    formatValues.refreshInterval = formatValues.refreshInterval
      ? Number(formatValues.refreshInterval)
      : null
    formatValues.refreshTriggerInterval = formatValues.refreshTriggerInterval
      ? Number(formatValues.refreshTriggerInterval)
      : null
    formatValues.translations = translations
    formatValues.parameters = formatValues.parameters
      ? JSON.parse(formatValues.parameters)
      : null

    const errors = await withPromise(sisenseChange, {
      entityId: this.getEntityId(),
      values: formatValues,
    })

    if (errors) {
      return errors
    }

    goBack()
    fetchProfile()
  }

  render() {
    const {
      isLoadForm,
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props

    if (isLoadForm) {
      return <Loader pastDelay />
    }

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton
            size="medium"
            className="btn-back"
            onClick={e => goBack(e)}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.sisenseDashboard)}
        </Typography>
        <SisenseForm formData={formData.toJS()} onSubmit={this.onSubmit} />
      </div>
    )
  }
}

SisenseDashboardItem.propTypes = {
  isLoadForm: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  intl: REACT_INTL_PROP_TYPE.isRequired,
  sisenseFetchFormData: PropTypes.func,
  sisenseClearStateForm: PropTypes.func,
  sisenseChange: PropTypes.func,
  fetchProfile: PropTypes.func,
}

SisenseDashboardItem.defaultProps = {
  sisenseFetchFormData: () => {},
  sisenseClearStateForm: () => {},
  sisenseChange: () => {},
  fetchProfile: () => {},
}

export default connect(
  state => ({
    isLoadForm: state.getIn(['sisense', 'isLoadForm']),
    formData: state.getIn(['sisense', 'formData']),
  }),
  {
    sisenseFetchFormData,
    sisenseClearStateForm,
    sisenseChange,
    fetchProfile,
  },
)(injectIntl(SisenseDashboardItem))
